import { ProcessTypeEnum } from "src/app/shared/interfaces/process.interface";

export class ProcessAvailability {
    enabled?: boolean;
    hidden: boolean;
    title?: string;
}

export class ProcessFeature {
    process: Record<ProcessTypeEnum, ProcessAvailability> = {
        [ProcessTypeEnum.GoalInputs]: { enabled: true, hidden: false, title: "performanceCycle.goalsInput" },
        [ProcessTypeEnum.GoalInputValidation]: { enabled: true, hidden: true, title: "performanceCycle.goalsInputValidation" },
        [ProcessTypeEnum.FreeEvaluationMidYear]: { enabled: true, hidden: false, title: "performanceCycle.freeEvalMidYear" },
        [ProcessTypeEnum.TwoPlusTwoCoaching]: { enabled: true, hidden: false, title: "performanceCycle.twoPlusTwoCoaching" },
        [ProcessTypeEnum.GoalsReview]: { enabled: true, hidden: false, title: "performanceCycle.goalsReviewAndCoaching" },
        [ProcessTypeEnum.TwoPlusTwoCoachingValidation]: { enabled: true, hidden: true, title: "performanceCycle.twoPlusTwoCoachingValidation" },
        [ProcessTypeEnum.GoalsReviewValidation]: { enabled: true, hidden: true, title: "performanceCycle.goalsReviewValidation" },
        [ProcessTypeEnum.ThreeSixtyEvaluatorsSelection]: { enabled: true, hidden: true, title: "performanceCycle.threeSixtyEvaluatorsSelection" },
        [ProcessTypeEnum.ThreeSixtyEvaluatorsValidation]: { enabled: true, hidden: true, title: "performanceCycle.threeSixtyEvaluatorsValidation" },
        [ProcessTypeEnum.ThreeSixtyEvaluation]: { enabled: true, hidden: false, title: "performanceCycle.threeSixtyEvaluation" },
        [ProcessTypeEnum.FreeEvaluationEndYear]: { enabled: true, hidden: false, title: "performanceCycle.freeEvalEndYear" },
        [ProcessTypeEnum.SelfEvaluation]: { enabled: true, hidden: false, title: "performanceCycle.selfEvaluation" },
        [ProcessTypeEnum.ManagerEvaluation]: { enabled: true, hidden: false, title: "performanceCycle.managerEvaluation" },
        [ProcessTypeEnum.EvaluationCalibration]: { enabled: true, hidden: false, title: "performanceCycle.evaluationCalibration" },
        [ProcessTypeEnum.EvaluationValidation]: { enabled: true, hidden: true, title: "performanceCycle.evaluationValidation" },
        [ProcessTypeEnum.FinalResult]: { enabled: true, hidden: false, title: "performanceCycle.FinalResult" },
        [ProcessTypeEnum.FinalFeedback]: { enabled: true, hidden: true, title: "performanceCycle.finalFeedback" },
        [ProcessTypeEnum.SelfEvaluationMidYear]: { enabled: true, hidden: false, title: "performanceCycle.selfEvaluationMidYear" },
        [ProcessTypeEnum.GenericProcess]: { enabled: true, hidden: false, title: "performanceCycle.GenericProcess" },
        [ProcessTypeEnum.HeadEvaluation]: { enabled: true, hidden: true, title: "performanceCycle.headEvaluation" },
        [ProcessTypeEnum.FinalFeedbackValidation]: { enabled: true, hidden: true, title: "performanceCycle.finalFeedbackValidation" },
    };
    constructor(processAvailability: Partial<Record<ProcessTypeEnum, ProcessAvailability>> = null) {
        if (processAvailability) {
            Object.entries(processAvailability).forEach(([key, override]) => {
                const original = this.process[key];

                this.process[key] = {
                    ...original,
                    ...override,
                };
            });
        }
    }
}
